<template>
  <div class="description-item">
    <div :style="labelStyle" class="label">
      {{label}}：
    </div>
    <div class="content">
      {{value}}
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'descriptionItem',
    props: {
      labelWidth: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      value: {
        default: ''
      }
    },
    inject: ['description'],
    data() {
      return {}
    },
    computed: {
      description() {
        let parent = this.$parent
        let parentName = parent.$options.name
        while (parentName !== 'description') {
          if (parentName === 'description') {
            this.isNested = true
          }
          parent = parent.$parent
          parentName = parent.$options.name
        }
        return parent
      },
      labelStyle() {
        const labelWidth = this.labelWidth || this.description.labelWidth
        return { width: labelWidth }
      }
    }
  }
</script>

<style scoped>
  .description-item {
    display: block;
    width: 100%;
    height: auto;
    min-height: 40px;
  }

  .description-item > .label {
    display: inline-block;
    vertical-align: middle;
    text-align: right;
    font-weight: bold;
    padding: 10px;
  }

  .description-item > .content {
    display: inline-block;
    vertical-align: middle;
    width: 400px;
    height: auto;
    text-align: left;
    padding: 10px 0;
    word-break: break-all;
    word-wrap: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/Description/descriptionItem.vue